function hideField(element, value) {
  const send_to_div = $("#" + element).parents(".row");
  const patronCategoryFields = send_to_div.next(".row");

  if (value === "all") {
    patronCategoryFields.hide();
  } else {
    patronCategoryFields.show();
  }
}

$(document).ready(function () {
  // Only run this logic if we're NOT on the messages/general/send page
  if (!window.location.pathname.includes('/messages/general/send')) {
    $(".patron_catagory_fields").hide();

    $(".send_to_buttons input[type=radio]:checked").each(function () {
      hideField(this.id, this.value);
    });

    $(document).on(
      "change",
      ".send_to_buttons input[type=radio]:checked",
      function () {
        hideField(this.id, this.value);
      }
    );
  }
});
